export default __webpack_public_path__ + "assets/icons/close-pic1.43ef9244.svg";